var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.item.title)+" ")]),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.dottedSubString(_vm.item.description))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }